"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveAssignationsOptions = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SortingPaginationOptions_1 = require("./SortingPaginationOptions");
let RetrieveAssignationsOptions = class RetrieveAssignationsOptions extends SortingPaginationOptions_1.SortingPaginationOptions {
};
exports.RetrieveAssignationsOptions = RetrieveAssignationsOptions;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "ids", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], RetrieveAssignationsOptions.prototype, "departureAtFrom", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], RetrieveAssignationsOptions.prototype, "departureAtTo", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], RetrieveAssignationsOptions.prototype, "createdAtFrom", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], RetrieveAssignationsOptions.prototype, "createdAtTo", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "driverIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "payoutIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "statusIn", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "orderIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], RetrieveAssignationsOptions.prototype, "searchString", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "subsidyIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "penaltyIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "compensationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "emailTypesSent", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "emailTypesNotSent", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveAssignationsOptions.prototype, "hasPendingScheduledEmails", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "automaticEmailMailgunIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveAssignationsOptions.prototype, "isInvoiced", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveAssignationsOptions.prototype, "currency", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveAssignationsOptions.prototype, "skip", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveAssignationsOptions.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.OrderType, { each: true }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RetrieveAssignationsOptions.prototype, "orderTypes", void 0);
exports.RetrieveAssignationsOptions = RetrieveAssignationsOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveAssignationsOptions);
//# sourceMappingURL=RetrieveAssignationsOptions.js.map